module.exports = __webpack_public_path__ + "img/big-1.ab9b82aa.png";